import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserProvider } from "@/entities/user/model/UserContext.jsx";
import useAxiosInterceptor from "@/shared/api/useAxiosInterceptor";
import { setupAdminAxiosInterceptor } from "@/shared/api/useAdminAxiosInterceptor.js";

export function AppProviders({ children }) {
    const navigate = useNavigate();

    useEffect(() => {
        setupAdminAxiosInterceptor(navigate);
    }, [navigate]);

    useAxiosInterceptor();

    return <UserProvider>{children}</UserProvider>;
}
